import { useRef } from 'react';
import _ from 'lodash';
import { Box, MenuItem, TextField } from '@material-ui/core';
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import { buildChartOptions, buildTrendCharts, TIME_RANGE_OPTIONS, useVitalsChartData } from './AgentHealthHelper';
import { useStyles as useChartStyles } from '../../charts/performance-chart/PerformanceChartStyles';
import PerformanceChart from '../../charts/performance-chart/PerformanceChart';
import AgentHealthEvents from './AgentHealthEvents';
import { useHealthStyles } from './AgentStyles';

const timeRangeFilterLabelText = i18n._(t`Time Range`);

export default function AgentHealthTrends({ agent, isHardwareAgent, isGlobalAgent, timeRange, setTimeRange }) {
    const classes = useHealthStyles();
    const chartClasses = useChartStyles();
    const baseChartOptions = useRef(buildChartOptions(agent));
    const chartAndMetrics = useRef(
        buildTrendCharts(agent, isHardwareAgent.current, isGlobalAgent.current, baseChartOptions.current)
    );
    const { chartData, refreshChartData } = useVitalsChartData(agent, chartAndMetrics.current.metrics, timeRange);

    const handleTimeRangeChange = (e) => {
        const timeRangeSelection = e.target.value;
        setTimeRange(timeRangeSelection);
        return refreshChartData(timeRangeSelection);
    };

    return (
        <Box mt={2} mb={5}>
            <Box mb={3} ml={2}>
                <TextField
                    className={classes.timeRangeSelect}
                    select
                    label={timeRangeFilterLabelText}
                    value={timeRange}
                    onChange={handleTimeRangeChange}
                >
                    {_.map(TIME_RANGE_OPTIONS, (value, key) => (
                        <MenuItem key={key} value={key}>
                            {value}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>

            <div className={classes.chartsContainer}>
                {_.map(chartAndMetrics.current.charts, (trendChart, idx) => (
                    <div key={idx} className={chartClasses.chartContainer}>
                        {trendChart.cardTitle}
                        <PerformanceChart chartDef={trendChart.config} data={chartData} initialHeight={150} />
                    </div>
                ))}
            </div>

            <AgentHealthEvents agent={agent} timeRange={timeRange} />
        </Box>
    );
}
